import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, Row, Col,
    FormGroup, Label, Input, Button
} from 'reactstrap';
import Select from 'react-select';
import { AuthContext } from '../../context/AuthContext';

import { TipoDespesasVendedorContext } from '../../context/TipoDespesasVendedorContext';
import { CreateTipoDespesasVendedorType } from '../../context/hooks/useTipoDespesasVendedor';

import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onCreated?: () => void;
}

export const CreateTipoDespesasVendedorModal: React.FC<Props> = ({ isOpen, toggle, onCreated }) => {
    const { objUserTk } = useContext(AuthContext);
    const { createTipoDespesasVendedor } = useContext(TipoDespesasVendedorContext);

    const [form, setForm] = useState<CreateTipoDespesasVendedorType>({
        name: '',
        icon: '',
        empresaId: objUserTk.EmpresaId,
    });

    useEffect(() => {
        if (isOpen) {
            setForm({
                name: '',
                icon: '',
                empresaId: objUserTk.EmpresaId,
            });
        }
    }, [isOpen]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const ok = await createTipoDespesasVendedor({
            ...form,
        });
        if (ok) {
            onCreated?.();
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Adicionar tipo de despesa</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Nome</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={onChange}
                                    placeholder="Nome"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Ícone</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="icon"
                                    value={form.icon}
                                    onChange={onChange}
                                    placeholder="Ícone"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">Criar tipo de despesa</Button>
                        <Button style={{ background: '#585858', color: '#fff' }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
export default CreateTipoDespesasVendedorModal;